import { render, staticRenderFns } from "./SettingsSM.vue?vue&type=template&id=6d8b0d14&"
import script from "./SettingsSM.vue?vue&type=script&lang=js&"
export * from "./SettingsSM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports